import { IDRCXAvailableColumnsDTO } from "./DRCXAvailableColumnsDTO";
import { DRCXAvailableEventColumn } from "./DRCXAvailableEventColumn";
import { DRCXAvailableOptionalColumn } from "./DRCXAvailableOptionalColumn";
import { DRCXAvailableTatColumn } from "./DRCXAvailableTatColumn";
import { DRCXAvailableTatTypeColumn } from "./DRCXAvailableTatTypeColumn";

export class DRCXAvailableColumns {
    public deviceTatColumns: Array<DRCXAvailableTatColumn> | undefined;
    public deviceOptionalColumns: Array<DRCXAvailableOptionalColumn> | undefined;
    public tankTatColumns: Array<DRCXAvailableTatColumn> | undefined;
    public tankOptionalColumns: Array<DRCXAvailableOptionalColumn> | undefined;
    public wellTatTypeColumns: Array<DRCXAvailableTatTypeColumn> | undefined;
    public wellOptionalColumns: Array<DRCXAvailableOptionalColumn> | undefined;
    public eventColumns: Array<DRCXAvailableEventColumn> | undefined;

    public constructor(dto: IDRCXAvailableColumnsDTO) {
        this.deviceTatColumns = dto.deviceTatColumns
            ? dto.deviceTatColumns.map(c => {
                return new DRCXAvailableTatColumn(c.dt, c.id, c.tdt, c.summaryFunction);
            })
            : undefined;
        this.deviceOptionalColumns = dto.deviceOptionalColumns
            ? dto.deviceOptionalColumns.map(c => {
                return new DRCXAvailableOptionalColumn(c.dt, c.oc, c.dt, undefined, undefined, undefined, c.id);
            })
            : undefined;
        this.eventColumns = dto.eventColumns
            ? dto.eventColumns.map(c => {
                return new DRCXAvailableEventColumn(c.dt, c.ec, c.ro);
            })
            : undefined;
        this.tankTatColumns = dto.tankTatColumns
            ? dto.tankTatColumns.map(c => {
                return new DRCXAvailableTatColumn(c.dt, c.id, c.tdt);
            })
            : undefined;
        this.tankOptionalColumns = dto.tankOptionalColumns
            ? dto.tankOptionalColumns.map(c => {
                return new DRCXAvailableOptionalColumn(c.dt, c.oc, c.dt, undefined, undefined, undefined, c.id);
            })
            : undefined;
        this.wellTatTypeColumns = dto.wellTatTypeColumns
            ? dto.wellTatTypeColumns.map(c => {
                return new DRCXAvailableTatTypeColumn(c.dt, c.id, c.tdt);
            })
            : undefined;
        this.wellOptionalColumns = dto.wellOptionalColumns
            ? dto.wellOptionalColumns.map(c => {
                return new DRCXAvailableOptionalColumn(c.dt, c.oc, c.dt, undefined, undefined, undefined, c.id);
            })
            : undefined;
    }
}

